import React from 'react';
import Link from 'next/link';

import { Typography } from 'lighthouse';

import { StarRating } from '../StarRating';
import { ReviewCardProps } from './models';

import { format } from 'date-fns-jalali';
import { Shop } from 'iconsax-react';

export const ReviewCard = ({ review }: ReviewCardProps) => {
    return (
        <div className='rounded-lg border border-solid border-gray-200 bg-gray-50 p-2 transition-all duration-200'>
            <div className='px-1'>
                <div className='flex items-center justify-between'>
                    <Typography className='font-semibold text-gray-800'>{review.userName ? review.userName : 'کاربر ازکی‌سرویس'}</Typography>
                    <Typography variant='caption' className='text-xs text-gray-400'>
                        {format(new Date(review.createdAt), 'yyyy/MM/dd')}
                    </Typography>
                </div>
                <StarRating size='sm' rating={review.rate} className='mb-4 mt-1' />
            </div>

            {review.metaData?.referenceParentTitle && (
                <div className='flex items-center gap-2 rounded-lg border border-solid border-gray-100 bg-white p-2'>
                    <Shop className='size-4 text-primary' color='currentcolor' />
                    <Link target='_blank' href={'/vendor/' + review.parentId} className='truncate text-xs font-semibold text-primary sm:text-sm'>
                        {review.metaData?.referenceParentTitle}
                    </Link>
                </div>
            )}

            <div className='mt-1 rounded-lg border border-solid border-gray-100 bg-white p-2'>
                <Typography variant='caption' className='text-xs leading-relaxed text-blackHighEmphasis sm:text-sm'>
                    {review.comment || 'بدون نظر'}
                </Typography>
            </div>
        </div>
    );
};
